export default "__VITE_PUBLIC_ASSET__ac888f64__"